export default "__VITE_ASSET__BS2uWFhX__"